import { Avatar, Badge, Box, Button, Container, Grid, Paper, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Texto from "./Texto";
import { TIPOS_DOCUMENTOS, TIPOS_MENSAJES } from "../../Constants";
import { axiosClient } from "../AxiosClient";
import Image from "./Image";
import Video from "./Video";
import Document from "./Document";
import { useParams } from "react-router-dom";
import Interactive from "./Interactive";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: '#44b700',
        color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
        },
        },
        '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
        },
    }));

const ButtonAdd = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px !important',
    gap: '10px !important',
    backgroundColor: '#161e55 !important',
    color: '#ffff !important',
    margin: '0px 1rem !important',
    '&:hover': {
        backgroundColor: '#A8C8AF !important',
    },
});

const searchByCellphone = (setState, cellphone) => {
    axiosClient.get(`/v1/conversations/commerce/${cellphone}`)
    .then(response => {
        setState(response.data);
        console.log(response.data)
    })
    .catch(error => {
        if (error.response) {
            console.log("Error with Axios");
        } else {
            console.log("Bad request: " + error.message);
        }
    });
}

const searchByDocument = (setState, clientDocument) => {
    axiosClient.get(`/v1/conversations/document/${clientDocument}`)
    .then(response => {
        setState(response.data);
    })
    .catch(error => {
        if (error.response) {
            console.log("Error with Axios");
        } else {
            console.log("Bad request: " + error.message);
        }
    });
}

export default function Conversacion() {
    const [datos, setData] = useState();
    const {documentClient, cellphone} = useParams();

    console.log(documentClient)
    console.log(cellphone)

    useEffect(() => {
        const interval = setInterval(() => {
            if(documentClient) {
                searchByDocument(setData, documentClient);
            } else {
                searchByCellphone(setData, cellphone);
            }
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    console.log(datos)

    return (
        <React.Fragment>
            <br></br>
            <Box sx={{width: '100%', marginTop: '1.7rem'}}>
                <Container>
                    <Item></Item>
                    <Item>.</Item>
                    <Grid container spacing={4} sx={{marginTop: '1rem', alignItems: 'center'}}>
                        <Grid item>
                            <h1>Conversaciones</h1>
                        </Grid>
                    </Grid>
                    <Grid container component={Paper} borderRadius={4} minHeight={'50vh'} maxHeight={'70vh'} sx={{overflow: 'auto'}} position={'relative'}>
                        <Grid item spacing={4} padding={1} sx={{bgcolor: 'gray'}} display={'flex'} alignItems={'center'} gap={1} width={'100%'} position={'sticky'} top={0} zIndex={1}>
                            <StyledBadge
                                overlap="circular"
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                variant="dot">
                                    <Avatar sx={{ bgcolor: 'orange' }}>{datos?.name}{datos?.lastName[0]}</Avatar>
                            </StyledBadge>
                            <Typography variant="body1">{datos?.name} {datos?.lastName}</Typography>
                        </Grid>
                        {datos?.messages.map(items => (
                            items.type === TIPOS_DOCUMENTOS.text ? 
                            <Texto key={items?.timeSent} texto={items?.message} tipos={items?.senderCellphone === datos?.cellphone ? TIPOS_MENSAJES.enviado : TIPOS_MENSAJES.recibido} times={items.timeSent}></Texto>
                            :
                            items.type === TIPOS_DOCUMENTOS.image ?
                            <Image key={items?.timeSent} imageKey={items.message} tipos={items?.senderCellphone === datos?.cellphone ? TIPOS_MENSAJES.enviado : TIPOS_MENSAJES.recibido} times={items.timeSent}></Image>
                            :
                            items.type === TIPOS_DOCUMENTOS.video ?
                            <Video key={items.timeSent} videKey={items.message} tipos={items?.senderCellphone === datos?.cellphone ? TIPOS_MENSAJES.enviado : TIPOS_MENSAJES.recibido} times={items.timeSent}></Video>
                            :
                            items.type === TIPOS_DOCUMENTOS.document ?
                            <Document key={items.timeSent} document={items.message} tipos={items?.senderCellphone === datos?.cellphone ? TIPOS_MENSAJES.enviado : TIPOS_MENSAJES.recibido} times={items.timeSent}></Document> 
                            :
                            items.type === TIPOS_DOCUMENTOS.interactive ?
                            <Interactive key={items.timeSent} texto={items?.message} content={items.buttons} tipos={items?.senderCellphone === datos?.cellphone ? TIPOS_MENSAJES.enviado : TIPOS_MENSAJES.recibido} times={items.timeSent}></Interactive>
                            : 
                            null
                        ))}
                    </Grid>
                </Container>
            </Box>
        </React.Fragment>
    );
}